import { render } from "./ListAlertConfigurations.vue?vue&type=template&id=446f412c"
import script from "./ListAlertConfigurations.vue?vue&type=script&lang=js"
export * from "./ListAlertConfigurations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__